export default "<p-toast [style]=\"{marginTop: '80px'}\"></p-toast>\n\n<router-outlet></router-outlet>\n<ngx-loading-bar color=\"white\"></ngx-loading-bar>";